import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';
import {textStart} from '~/actions/AnalyticsActions';
import {getSelectedIconsArray} from '~/selectors/CanvasSelectors';
import {isAddToClipartEnabled} from '~/selectors/ConfigSelectors';
import {
  allowsNamesAndNumbers,
  getErrorFreeSelectedProduct
} from '~/selectors/ProductSelectors';

export const select = () => {
  return createStructuredSelector({
    allowsNamesAndNumbers,
    selectedIcons: getSelectedIconsArray,
    isAddToClipartEnabled: isAddToClipartEnabled,
    currentProduct: getErrorFreeSelectedProduct
  });
};

export const actions = dispatch => {
  return {
    analytics: {
      textStart: bindActionCreators(textStart, dispatch)
    }
  };
};
